export const retrieveSales = (state, data) => {
  state.sales = data.data
  state.pagination.links = data.links
  state.pagination.meta = data.meta
}